import './BackgroundOrbs.css';

const BackgroundOrbs = () => (
  <div className='background-orbs' aria-hidden='true'>
    <div className='orb orb--1' />
    <div className='orb orb--2' />
    <div className='orb orb--3' />
  </div>
);

export default BackgroundOrbs;
